<div class="periode" [attr.aria-busy]="loading">
  <span class="periode-skeleton" *ngIf="loading" aria-hidden="true"></span>

  <span class="periode-error" role="alert" *ngIf="errorMessage">{{ errorMessage }}</span>

  <ng-container *ngIf="!loading && !errorMessage">
    <ng-container *ngIf="!editing && active">
      <span class="periode-label">Periode</span>
      <strong class="periode-value" id="cashier-periode-active">{{ label(active) }}</strong>
      <button type="button" class="periode-btn periode-btn--ghost" id="cashier-periode-change" *ngIf="!readonly" (click)="change()">
        Ganti
      </button>
    </ng-container>

    <ng-container *ngIf="editing">
      <label class="periode-label" for="cashier-periode">Periode</label>
      <select
        id="cashier-periode"
        class="periode-select"
        [(ngModel)]="selectedPeriodeId"
        [disabled]="!periodes.length"
      >
        <option *ngIf="!periodes.length" [ngValue]="null">Tidak ada periode aktif</option>
        <option *ngFor="let periode of periodes" [ngValue]="periode.id">{{ label(periode) }}</option>
      </select>
      <button type="button" class="periode-btn periode-btn--primary" id="cashier-periode-confirm" [disabled]="!selected" (click)="confirm()">
        Pilih
      </button>
      <button type="button" class="periode-btn periode-btn--ghost" id="cashier-periode-cancel" *ngIf="active" (click)="cancel()">
        Batal
      </button>
    </ng-container>
  </ng-container>
</div>
